import styled, { keyframes } from 'styled-components';

export const DEMO_BREAKPOINT = 767;

export const Frame = styled.div`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: min(1400px, calc(100vw - 32px));
  height: ${(p) => (p.$tall ? 'max(640px, calc(100vh - 190px))' : 'min(78vh, 760px)')};
  min-height: 560px;
  border: 1px solid #d8dbe0;
  border-radius: 12px;
  overflow: hidden;
  background: #212631;
  box-shadow: 0 24px 60px rgba(15, 33, 55, 0.18);

  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    background: #f3f4f7;
  }

  @media (max-width: ${DEMO_BREAKPOINT}px) {
    display: none;
  }
`;

export const Placeholder = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  text-align: center;
  color: #fff;
  background: linear-gradient(135deg, #212631 0%, #3c4b64 100%);

  p {
    margin: 0;
    max-width: 420px;
    color: #d8dbe0;
    font-size: 15px;
    line-height: 1.6;
  }
`;

export const TryButton = styled.button`
  appearance: none;
  border: 0;
  border-radius: 6px;
  padding: 14px 28px;
  background: #f9b115;
  color: #212631;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: #ffc43d;
  }
  &:focus-visible {
    outline: 3px solid #fff;
    outline-offset: 2px;
  }
`;

export const FrameNote = styled.p`
  margin: 16px 0 0;
  color: #5d646d;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;

  a {
    color: #2965cc;
    font-weight: 600;
  }

  @media (max-width: ${DEMO_BREAKPOINT}px) {
    display: none;
  }
`;

// ---- mobile preview ------------------------------------------------------------------------

const STEP_SECONDS = 3.2;
// One preview frame per guide stage (see PREVIEW in index.js).
export const PREVIEW_FRAMES = 7;
const SLOT = 100 / PREVIEW_FRAMES;

// One frame is visible per slot (1/PREVIEW_FRAMES of the cycle); the fade-out ends before the next
// fade-in starts, so two frames never overlap.
const fade = keyframes`
  0% { opacity: 0; }
  1.5% { opacity: 1; }
  ${(SLOT - 1.2).toFixed(2)}% { opacity: 1; }
  ${(SLOT - 0.2).toFixed(2)}% { opacity: 0; }
  100% { opacity: 0; }
`;

export const Mobile = styled.div`
  display: none;

  @media (max-width: ${DEMO_BREAKPOINT}px) {
    display: block;
  }
`;

export const PreviewStage = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  border: 1px solid #d8dbe0;
  border-radius: 10px;
  overflow: hidden;
  background: #f3f4f7;
  box-shadow: 0 12px 30px rgba(15, 33, 55, 0.14);

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    animation: ${fade} ${STEP_SECONDS * PREVIEW_FRAMES}s infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    img {
      animation: none;
    }
    img:last-of-type {
      opacity: 1;
    }
  }
`;

export const frameDelay = (index) => `${index * STEP_SECONDS}s`;
export const Caption = styled.ol`
  list-style: none;
  margin: 14px 0 0;
  padding: 0;
  display: grid;
  gap: 6px;
  color: #3c4b64;
  font-size: 14px;
  line-height: 1.5;

  li {
    display: flex;
    gap: 8px;
  }
  span {
    flex: none;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #0f2137;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    line-height: 22px;
  }
`;

export const DesktopHint = styled.div`
  margin-top: 18px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #eef3fb;
  color: #0f2137;
  font-size: 15px;
  line-height: 1.55;

  strong {
    display: block;
    margin-bottom: 4px;
  }
  a.hint-link {
    display: inline-block;
    margin-top: 10px;
    padding: 10px 18px;
    border-radius: 6px;
    background: #0f2137;
    color: #fff;
    font-weight: 700;
    text-decoration: none;
  }
  a.hint-secondary {
    display: inline-block;
    margin: 10px 0 0 14px;
    color: #2965cc;
    font-weight: 600;
  }
`;
